import { render, staticRenderFns } from "./bgs-list.vue?vue&type=template&id=47edf8bc"
import script from "./bgs-list.vue?vue&type=script&lang=js"
export * from "./bgs-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports